/* 
    Author: Jiaqi Duan
    Created on: 09/02/2023
*/

import HomePage from "./component/HomePage";

export default function App() {
  return <HomePage />;
}
